module.exports = "/shared/img/red-btn-background.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/red-btn-background.png
// module id = 14
// module chunks = 13